import React, { useState } from "react";
import { ArrowUp, Instagram, Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export default function Footer({ showNewsletter = false }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!/.+@.+\..+/.test(email)) { toast.error("Inserisci una email valida"); return; }
    setBusy(true);
    try {
      await api.post("/public/newsletter/subscribe", { email: email.trim().toLowerCase() });
      toast.success("Iscrizione ricevuta! Ti scriveremo prima della 1ª giornata.");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore invio iscrizione, riprova.");
    } finally { setBusy(false); }
  };

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <>
      {/* Newsletter strip — visibile solo in Home */}
      {showNewsletter && (
        <section className="w-full mt-10" data-testid="newsletter-strip"
                 style={{ background: "linear-gradient(90deg, #3b56e0, #6366f1 50%, #f97316)" }}>
          <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 items-center">
            <div>
              <div className="text-white/80 text-[11px] uppercase tracking-widest font-bold">Newsletter FIFE</div>
              <div className="display font-black text-2xl md:text-3xl text-white mt-1">Iscriviti alla newsletter</div>
              <p className="text-white/85 text-sm mt-1">Anteprime aste, calendari, pronostici e Gufate direttamente nella tua casella.</p>
            </div>
            <form onSubmit={subscribe} className="flex flex-col sm:flex-row gap-2 w-full md:w-[420px]">
              <div className="flex-1 relative">
                <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="tuomail@esempio.it"
                       className="h-11 pl-9 bg-white border-transparent text-slate-900 rounded-full" data-testid="newsletter-email" />
              </div>
              <Button type="submit" disabled={busy} className="h-11 rounded-full bg-slate-900 hover:bg-black text-white font-semibold px-5" data-testid="newsletter-submit">
                {busy ? "Invio..." : "Iscriviti"}
              </Button>
            </form>
          </div>
        </section>
      )}

      {/* Dark footer */}
      <footer className="w-full" style={{ background: "#0a0a0a" }} data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 flex items-center justify-between gap-4 flex-wrap">
          <p className="text-white/80 text-sm md:text-[15px]" data-testid="footer-copyright">
            © 2026 Federazione Italiana Fantaleghe Elite, C.F. 94159600306. All Rights Reserved
          </p>
          <div className="flex items-center gap-2">
            <a href="https://www.instagram.com/fantaleghe_elite/" target="_blank" rel="noreferrer noopener"
               aria-label="Instagram" data-testid="social-instagram"
               className="w-10 h-10 rounded-full border border-white/25 text-white hover:bg-white/10 inline-flex items-center justify-center transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <button onClick={scrollTop} data-testid="footer-back-to-top"
                    className="ml-2 w-11 h-11 rounded-full border border-white/25 text-white hover:bg-white/10 inline-flex items-center justify-center transition-colors"
                    aria-label="Torna su" title="Torna su">
              <ArrowUp className="w-5 h-5" />
            </button>
          </div>
        </div>
      </footer>
    </>
  );
}
